//ServiceAreaChecker.js
import React, { useState } from 'react';
import './ServiceAreaChecker.css';

const ServiceAreaChecker = () => {
const [zipCode, setZipCode] = useState('');
const [checkResult, setCheckResult] = useState(null);
const [isChecking, setIsChecking] = useState(false);

// Northern Virginia zip codes - customize this list based on your service area
const novaZipCodes = [
// Arlington
22201, 22202, 22203, 22204, 22205, 22206, 22207, 22209, 22211, 22213, 22214,
// Alexandria 
22301, 22302, 22303, 22304, 22305, 22306, 22307, 22308, 22309, 22310, 22311, 22312, 22314, 22315,
// Fairfax County
22030, 22031, 22032, 22033, 22034, 22035, 22036, 22037, 22038, 22039, 22040, 22041, 22042, 22043, 22044, 22046,
22060, 22066, 22101, 22102, 22103, 22106, 22107, 22108, 22109, 22116, 22121, 22122, 22124, 22150, 22151, 22152,
22153, 22156, 22158, 22159, 22160, 22161, 22180, 22181, 22182, 22183, 22184, 22185,
// Loudoun County
20105, 20117, 20129, 20130, 20132, 20135, 20141, 20147, 20148, 20152, 20158, 20164, 20165, 20166, 20175, 20176, 20177, 20178, 20180, 20197,
// Prince William County
20109, 20110, 20111, 20112, 20136, 20137, 20143, 20155, 20156, 20169, 20181, 20182, 22025, 22026, 22172, 22191, 22192, 22193, 22194, 22195
// Add more zip codes as needed
];

const checkZipCode = () => {
if (!zipCode.trim() || zipCode.length !== 5 || isNaN(Number(zipCode))) {
    setCheckResult({
    inServiceArea: false,
    message: 'Please enter a valid 5-digit zip code.'
    });
    return;
}

setIsChecking(true);

// Simulate a brief loading delay (optional)
setTimeout(() => {
    const zipCodeNum = parseInt(zipCode, 10);
    const inServiceArea = novaZipCodes.includes(zipCodeNum);

    setCheckResult({
    inServiceArea: inServiceArea,
    message: inServiceArea
        ? `Great news! We service zip code ${zipCode}. Please reach out to us via Facebook to learn more.`
        : `Sorry, we currently don't service your area ( ${zipCode} ). We're only operating in Northern Virginia at this time.`
    });

    setIsChecking(false);
}, 600);
};

const handleKeyPress = (e) => {
if (e.key === 'Enter') {
    checkZipCode();
}
};

return (
<div className="service-area-checker">
    <div className="checker-container">
    <div className="checker-prompt">
        Want to rent? Check if you are in our service area!
    </div>
    <div className="checker-input">
        <input
        type="text"
        value={zipCode}
        onChange={(e) => setZipCode(e.target.value.slice(0, 5))}
        onKeyPress={handleKeyPress}
        placeholder="Enter zip code..."
        maxLength={5}
        />
        <button 
        onClick={checkZipCode}
        disabled={isChecking}
        className={isChecking ? 'checking' : ''}
        >
        {isChecking ? '...' : 'go!'}
        </button>
    </div>
    </div>

    {checkResult && (
    <div className={`result-message ${checkResult.inServiceArea ? 'success' : 'error'}`}>
        <p>{checkResult.message}</p>
        {checkResult.inServiceArea && (
        <button 
            className="facebook-contact-button"
            onClick={() => window.open('https://www.facebook.com/hiddencapabilities/', '_blank')}
        >
            Reach out on Facebook
        </button>
        )}
    </div>
    )}
</div>
);
};

export default ServiceAreaChecker;
